export const shouldDisplayRankingRow = (row) => {
  const hasSubscribers = Array.isArray(row?.subscriber_names) && row.subscriber_names.length > 0;

  return (
    hasSubscribers &&
    !row?.is_mora_quarantine &&
    !row?.is_archived &&
    !row?.pre_adjudication_date
  );
};
